import { ReactNode } from "react";

import { Alert, AlertColor, Paper, Stack, Typography } from "@mui/material";

interface Props {
  severity: AlertColor;
  title: ReactNode;
  children: ReactNode;
}

export function AlertPanel({ severity, title, children }: Props) {
  const accentColor = `${severity}.main`;

  return (
    <Stack>
      <Alert
        severity={severity}
        sx={{
          border: 1,
          borderBottom: 0,
          borderColor: accentColor,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        <Typography sx={{ fontWeight: "bold" }}>{title}</Typography>
      </Alert>

      <Paper
        variant="outlined"
        sx={{ p: 2, borderColor: accentColor, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
      >
        {children}
      </Paper>
    </Stack>
  );
}
